<template>
    <div class="row">
        <div class="input-group col-sm-9">
            <div class="input-group-prepend">
                <select :name="name + '_country'"
                        :id="name + '_country'"
                        :aria-label="$t('phoneForm.country')"
                        class="form-control custom-select"
                        style="max-width: 140px"
                        v-model="phone.countryCode"
                        v-validate="'conutryCode'"
                        @input="handleChange">
                    <option v-for="country in Geo.getCountriesByName()"
                            :value="country.countryCode">
                        {{ country.phoneCode }} – {{ country.name }}
                    </option>
                </select>
            </div>
            <input :name="name"
                   :id="name"
                   :required="!!required"
                   :placeholder="$t('phoneForm.number')"
                   class="form-control"
                   v-model="phone.number"
                   v-validate="'number'"
                   @input="handleChange">
        </div>
        <div class="col-sm-3" v-if="!hideExtension">
            <input :name="name + '_extension'"
                   :id="name + '_extension'"
                   :placeholder="$t('phoneForm.ext')"
                   v-model="phone.extension"
                   v-validate="'extension'"
                   class="form-control"
                   @input="handleChange">
        </div>
    </div>
</template>

<script>
    import Geo from '../../../../src/Utils/Geo';

    export default {
        name: 'PhoneNumberForm',
        props: [
            'name',
            'required',
            'phone',
            'hideExtension',
            'errors'
        ],
        data() {
            return {
                Geo
            };
        },
        methods: {
            handleChange() {
                this.$emit('phone-changed', this.phone);
            }
        }
    };
</script>

<style scoped>

</style>